import { getAccessToken } from '@/utils/auth';

const getters = {
  // 直接读响应式令牌，保证拦截器清空令牌后组件也能立刻感知
  token: () => getAccessToken(),
  user: state => state.user.user
};
export default getters;
